import { lt, useFormControls } from '@mews/framework';
import { WithScope } from '@mews-commander/types';
import { SearchType } from '@mews-commander/enums';
import { useCommanderSelector } from '@mews-commander/utils';
import { FormLayout } from '../../FormLayout';
import { SearchHookField } from '../../../../../components/form/hookFields';
import { getCheckedReservationCompanionIds } from '../selectors';
import { GroupExistingCustomerFormKeys, defaultValues, resolver } from './types';
import { useAddCompanionshipsMutation } from './useAddCompanionshipsMutation';

interface GroupExistingCustomerProps extends WithScope {
    reservationId: string;
    onSuccess?: () => void;
    canCreateNewOne?: boolean;
}

export const GroupExistingCustomer = ({
    scope,
    onSuccess,
    reservationId,
    canCreateNewOne = false,
}: GroupExistingCustomerProps) => {
    const checkedReservationCompanionIds = useCommanderSelector((state) =>
        getCheckedReservationCompanionIds(state, { scope, groupId: scope })
    );

    const { mutate, isPending } = useAddCompanionshipsMutation({
        groupId: scope,
        reservationId,
    });

    const { renderFormContent, reset } = useFormControls({
        onSubmit: (v) => {
            mutate(v, {
                onSuccess: () => {
                    onSuccess?.();
                    reset();
                },
            });
        },
        resolver,
        defaultValues,
        dataTestForm: 'group-existing-customer-form',
        id: `companionship-add-form-${scope}`,
    });

    return renderFormContent(
        <FormLayout
            vertical
            loading={isPending}
            submitButtonText={lt('AddExistingCustomerSubmitButton')}
            title={lt('AddExistingCustomer')}
        >
            <SearchHookField
                data-test-id={GroupExistingCustomerFormKeys.companionId}
                newEntity={canCreateNewOne}
                name={GroupExistingCustomerFormKeys.companionId}
                placeholder={lt('SearchByName')}
                label={lt('Customer')}
                searchTypes={[SearchType.Customer]}
                except={checkedReservationCompanionIds} // Exclude the current group from the search
            />
        </FormLayout>
    );
};
